import _styled from "@emotion/styled/base";
const Container = /*#__PURE__*/_styled("h3", process.env.NODE_ENV === "production" ? {
  target: "eitajqu0"
} : {
  target: "eitajqu0",
  label: "Container"
})("word-break:break-word;", props => props.$isEnableTextOverflowEllipsis ? `
        display: -webkit-box;

        text-overflow: ellipsis;

        overflow: hidden;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        line-clamp: 3;
      ` : null, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9hcHAvcGFja2FnZXMvc2hhcmVkL3NyYy9jb21wb25lbnRzL2NvbnRlbnQvY29udGVudC1zdW1tYXJ5L3N0eWxlcy50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTXdDIiwiZmlsZSI6Ii9hcHAvcGFja2FnZXMvc2hhcmVkL3NyYy9jb21wb25lbnRzL2NvbnRlbnQvY29udGVudC1zdW1tYXJ5L3N0eWxlcy50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gXCJAZW1vdGlvbi9zdHlsZWRcIjtcblxudHlwZSBTdHlsZWRQcm9wcyA9IHtcbiAgJGlzRW5hYmxlVGV4dE92ZXJmbG93RWxsaXBzaXM6IGJvb2xlYW47XG59O1xuXG5jb25zdCBDb250YWluZXIgPSBzdHlsZWQuaDM8U3R5bGVkUHJvcHM+YFxuICB3b3JkLWJyZWFrOiBicmVhay13b3JkO1xuXG4gICR7cHJvcHMgPT5cbiAgICBwcm9wcy4kaXNFbmFibGVUZXh0T3ZlcmZsb3dFbGxpcHNpc1xuICAgICAgPyBgXG4gICAgICAgIGRpc3BsYXk6IC13ZWJraXQtYm94O1xuXG4gICAgICAgIHRleHQtb3ZlcmZsb3c6IGVsbGlwc2lzO1xuXG4gICAgICAgIG92ZXJmbG93OiBoaWRkZW47XG4gICAgICAgIC13ZWJraXQtYm94LW9yaWVudDogdmVydGljYWw7XG4gICAgICAgIC13ZWJraXQtbGluZS1jbGFtcDogMztcbiAgICAgICAgbGluZS1jbGFtcDogMztcbiAgICAgIGBcbiAgICAgIDogbnVsbH1cbmA7XG5cbmV4cG9ydCBjb25zdCBIMkNvbnRhaW5lciA9IENvbnRhaW5lci53aXRoQ29tcG9uZW50KFwiaDJcIik7XG5leHBvcnQgY29uc3QgSDNDb250YWluZXIgPSBDb250YWluZXIud2l0aENvbXBvbmVudChcImgzXCIpO1xuIl19 */"));
export const H2Container = Container.withComponent("h2", process.env.NODE_ENV === "production" ? {
  target: "eitajqu1"
} : {
  target: "eitajqu1",
  label: "H2Container"
});
export const H3Container = Container.withComponent("h3", process.env.NODE_ENV === "production" ? {
  target: "eitajqu2"
} : {
  target: "eitajqu2",
  label: "H3Container"
});